import { tsValidateString, tsValidateUniqueId } from '@nu-art/ts-common';
import { knowledgeManagerDBGroup } from '@app/hcs-shared';
import { DBDef_FlowSheet } from '@app/advisor-content-shared';
import { DBDef_EHROrderConfiguration } from '../ehr-order-configuration/index.js';
const Validator_ModifiableProps = {
    label: tsValidateString(),
    ehrInstanceId: tsValidateUniqueId,
    dbNoteId: tsValidateUniqueId,
    ehrNoteCode: tsValidateString(),
};
const Validator_GeneratedProps = {};
export const DBDef_EHRFlowsheetConfiguration = {
    modifiablePropsValidator: Validator_ModifiableProps,
    generatedPropsValidator: Validator_GeneratedProps,
    versions: ['1.0.1', '1.0.0'],
    dbKey: 'ehr-flowsheet-configuration',
    entityName: 'EHR Flowsheet Configuration',
    frontend: {
        group: knowledgeManagerDBGroup,
        name: 'ehr-flowsheet-configuration'
    },
    backend: {
        name: 'ehr-flowsheet-configuration'
    },
    dependencies: {
        ehrInstanceId: {
            dbKey: DBDef_EHROrderConfiguration.dbKey,
            fieldType: 'string',
        },
        dbNoteId: {
            dbKey: DBDef_FlowSheet.dbKey,
            fieldType: 'string',
        }
    }
};
//# sourceMappingURL=db-def.js.map